// src/App.js
import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./components/login/Login";
import Dashboard from "./components/dashboard/Dashboard";
import { getSession } from "./services/auth";
import NewRegistration from "./components/newregistration/NewRegistration";
import Forgot from "./components/forgot/Forgot";

function ProtectedRoute({ children }) {
  const s = getSession();
  return s?.logged_in ? children : <Navigate to="/" replace />;
}

export default function App() {
  const [session, setSession] = useState(getSession());

  useEffect(() => {
    const refresh = () => setSession(getSession());

    // fired by setSession() / clearSession()
    window.addEventListener("authchange", refresh);

    // if you logout/login in another tab
    window.addEventListener("storage", refresh);

    return () => {
      window.removeEventListener("authchange", refresh);
      window.removeEventListener("storage", refresh);
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            session?.logged_in ? <Navigate to="/dashboard" replace /> : <Login />
          }
        />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        <Route path="/register" element={<NewRegistration />} />
        <Route path="/forgot" element={<Forgot />} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
